import React from 'react';
import { createBrowserRouter, redirect } from 'react-router-dom';
import {
  HomePage,
  LoginPage,
  RegisterPage,
  ProfilePage,
  NotFoundPage,
  NotificationPage,
  VerifyAccountPage,
  ProfileUserPage,
  FriendPage,
} from '../pages';

import { routePaths } from './routes-path';
import { DonateGoalPage } from '../pages/donate-goal';
import DefaultLayout from '../components/layouts/default-layout';
import BlankLayout from '../components/layouts/blank-layout';
import PrivateRoute from '../components/route/private-route.component';
import { ListFriendPage } from '../pages/list-friend';
import { ChatPage } from '../pages/chat';
import { VideosPage } from '../pages/videos';
import ReelsPage from '../pages/reels';
import StudioPage from '../pages/studio/studio.page';
import AdsPage from '../pages/ads/ads.page';
import ShopPage from '../pages/shop/shop.page';
import PublisherPage from '../pages/publisher/publisher.page';
import PartnerPage from '../pages/partner/partner.page';
import ManagementAds from '../pages/admin/page/ManagementAds';
import ManagementBrandDeals from '../pages/admin/page/ManagementBrandDeals';
import ManagementAffiliate from '../pages/admin/page/ManagementAffiliate';
import ManagementArena from '../pages/admin/page/ManagementArena';
import ManagementPublisher from '../pages/admin/page/ManagementPublisher';
import ManagementConsent from '../pages/admin/page/ManagementConsent';
import DaoCaPage from '../pages/gamification/dao-ca.page';
import { DatingPage } from '../pages/dating';
import VideosLayout from '../components/layouts/videos-layout';
import UserSetting from '../pages/user-setting/user-setting';
import PageDonateLivestream from '../pages/page-donate-livestream/page-donate-livestream.component';
import PageDonateGoalLivestream from '../pages/page-donate-goal-livestream/page-donate-goal-livestream.component';
import PageTopDonateLivestream from '../pages/page-top-donate-livestream/page-top-donate-livestream.component';
import PageSpinWheelLivestream from '../pages/page-spin-wheel-livestream/page-spin-wheel-livestream.component';
import PageDonatePollLivestream from '../pages/page-donate-poll-livestream/page-donate-poll-livestream.component';
import PageDonateChallengeLivestream from '../pages/page-donate-challenge-livestream/page-donate-challenge-livestream.component';
import PageAdLivestream from '../pages/page-ad-livestream/page-ad-livestream.component';
import PageMusicLivestream from '../pages/page-music-livestream/page-music-livestream.component';
import PageMemberLivestream from '../pages/page-member-livestream/page-member-livestream.component';
import PageLiveEffectLivestream from '../pages/page-live-effect-livestream/page-live-effect-livestream.component';
import PageSubathonLivestream from '../pages/page-subathon-livestream/page-subathon-livestream.component';
import MusicControlPage from '../pages/music-control/music-control.page';
import PageAiQuestionLivestream from '../pages/page-ai-question-livestream/page-ai-question-livestream.component';
import AiQuestionControlPage from '../pages/ai-question-control/ai-question-control.page';
import AffiliateGoPage from '../pages/affiliate-go/affiliate-go.page';
import PublicProductPage from '../pages/public-product/public-product.page';
import GroupPage from '../pages/group/group.page';
import GroupDetail from '../pages/group-detail';
import WalletPage from '../pages/wallet/wallet.page';
import DonatePage from '../pages/donate/donate.page';
import BrandDealsPage from '../pages/brand-deals/brand-deals.page';
import BrandOrdererPage from '../pages/brand-deals/brand-orderer.page';
import BrandTaskWorkspacePage from '../pages/brand-deals/brand-task-workspace.page';
import BrandOrdererProfilePage from '../pages/brand-deals/brand-orderer-profile.page';
import InventoryPage from '../pages/wallet/inventory.page';
import ClanListPage from '../pages/clan/clan-list.page';
import ClanDetailPage from '../pages/clan/clan-detail.page';
import ArenaListPage from '../pages/arena/arena-list.page';
import ArenaDetailPage from '../pages/arena/arena-detail.page';
import AdminLoginPage from '../pages/admin/login.page';
import AdminPage from '../pages/admin/admin.page';
import CreatorSuggestionPage from '../pages/creator-suggestion';
import CabPlusPage from '../pages/cab-plus';
import HomeAdmin from '../pages/admin/page/HomeAdmin';
import AdminLayout from '../pages/admin/layout/DefaultLayout';
import { SavedPostsPage } from '../pages/saved-posts/saved-posts.page';
import SearchPage from '../pages/search/search.page';
import ManagementUser from '../pages/admin/page/ManagementUser';
import ManagementRequestDonate from '../pages/admin/page/ManagementRequestDonate';
import HashtagPage from '../pages/hastag/hastag.page';
import { ResetPasswordPage } from '../pages/reset-password';
import LoginByCodePage from '../pages/admin/codeLoginCheck.page';
import ManagementPost from '../pages/admin/page/ManagementPost';
import ManagementReportPost from '../pages/admin/page/ManagementReportPost';
import PostUncheck from '../pages/post-uncheck';
import { CategoryPage } from '../pages/category';
import OldPage from '../pages/old/old.page';
import HonorPage from '../pages/honor/honor.page';
import CampaignMarketPage from '../pages/campaigns/campaign-market.page';
import CampaignDetailPage from '../pages/campaigns/campaign-detail.page';
import DonateEventPage from '../pages/donate-event/donate-event.page';
import { ForgotPasswordPage } from '../pages/forgot-password';
import VnPayResult from '../pages/VNPayResult';
import ManagementHiddenPost from '../pages/admin/page/ManagementHiddenPost';
import TransactionHistory from '../pages/transaction-history';
import ManagementReportComment from '../pages/admin/page/ManagementReportComment';
import ManagementReportProfileImage from '../pages/admin/page/ManagementReportProfileImage';
import ManagementReportClan from '../pages/admin/page/ManagementReportClan';
import ManagementReportAccount from '../pages/admin/page/ManagementReportAccount';
import ManagementHiddenComment from '../pages/admin/page/ManagementHiddenComment';
import ManagementWithdrawRequest from '../pages/admin/page/ManagementWithdrawRequest';
import ManagementRevenueReport from '../pages/admin/page/ManagementRevenueReport';
import ManagementTopUpReport from '../pages/admin/page/ManagementTopUpReport';
import ManagementRequestCreator from '../pages/admin/page/ManagementRequestCreator';
import ManagementPendingPost from '../pages/admin/page/ManagementPendingPost';
import ManagementArchivePost from '../pages/admin/page/ManagementArchivePost';
import ManagementRoles from '../pages/admin/page/ManagementRoles';
import ManagementCosmetic from '../pages/admin/page/ManagementCosmetic';
import ManagementDonateEvent from '../pages/admin/page/ManagementDonateEvent';
import ManagementGamification from '../pages/admin/page/ManagementGamification';
import ManagementSettings from '../pages/admin/page/ManagementSettings';
import ManagementAuditLog from '../pages/admin/page/ManagementAuditLog';
import ManagementQueryGuard from '../pages/admin/page/ManagementQueryGuard';
import ManagementSecurity from '../pages/admin/page/ManagementSecurity';
import ManagementEkycUsage from '../pages/admin/page/ManagementEkycUsage';

export const RouterLinks = createBrowserRouter([
  {
    path: '/',
    children: [
      {
        element: <DefaultLayout />,
        children: [
          {
            index: true,
            element: <HomePage />,
          },
          {
            // Công khai — xem không cần đăng nhập (feature /old)
            path: routePaths.old,
            element: <OldPage />,
          },
          {
            // Bảng vinh danh — công khai, xem không cần đăng nhập.
            path: routePaths.honor,
            element: <HonorPage />,
          },
          {
            // Sàn chiến dịch — công khai, xem không cần đăng nhập (nhận việc ở trang chi tiết mới cần đăng nhập).
            path: routePaths.campaigns,
            element: <CampaignMarketPage />,
          },
          {
            path: routePaths.campaignDetail,
            element: <CampaignDetailPage />,
          },
          {
            // Trang sự kiện thử thách donate — công khai, xem không cần đăng nhập.
            path: routePaths.donateEvent,
            element: <DonateEventPage />,
          },
          {
            element: <PrivateRoute />,
            children: [
              // {
              //   index: true,
              //   element: <HomePage />,
              // },
              {
                path: 'share/post/:id', // Matches "/share/..." with dynamic segments
                element: <HomePage />, // Replace with your SharePage component
              },
              {
                path: routePaths.notifications,
                Component: NotificationPage,
              },
              {
                path: routePaths.creatorsSuggestion,
                Component: CreatorSuggestionPage,
              },
              {
                path: routePaths.savePost,
                Component: SavedPostsPage,
              },
              {
                path: routePaths.search,
                Component: SearchPage,
              },
              {
                path: routePaths.profile,
                element: <ProfilePage />,
              },
              {
                path: routePaths.donateGoal,
                element: <DonateGoalPage />,
              },
              {
                path: routePaths.donate,
                element: <DonatePage />,
              },
              {
                // Creator: nhận lời mời hợp tác quảng cáo trực tiếp từ doanh nghiệp (Brand Deal).
                path: routePaths.brandDeals,
                element: <BrandDealsPage />,
              },
              {
                // Người thuê creator: tạo chiến dịch, brief, đơn nhận đề xuất.
                path: routePaths.brandOrderer,
                element: <BrandOrdererPage />,
              },
              {
                // Creator: bàn soạn bài 1 nhiệm vụ brief sáng tạo (M3).
                path: routePaths.brandTaskWorkspace,
                element: <BrandTaskWorkspacePage />,
              },
              {
                // Hồ sơ đánh giá của người đặt (spec 2026-10-12 §4) — cần đăng nhập.
                path: routePaths.brandOrdererProfile,
                element: <BrandOrdererProfilePage />,
              },
              {
                // Bảng điều khiển phát nhạc theo yêu cầu (duyệt bài, bỏ qua, tạm dừng).
                path: routePaths.musicControl,
                element: <MusicControlPage />,
              },
              {
                // Bảng điều khiển hỏi đáp AI (duyệt câu hỏi, đọc câu trả lời, phát lên live).
                path: routePaths.aiQuestionControl,
                element: <AiQuestionControlPage />,
              },
              {
                path: routePaths.marketplace,
                element: <WalletPage />,
              },
              {
                path: routePaths.cabPlus,
                Component: CabPlusPage,
              },
              {
                // Ví Ca (trang THUẦN): chỉ dashboard số dư/ví Ca, ẩn Marketplace.
                path: routePaths.wallet,
                element: <WalletPage walletOnly />,
              },
              {
                // Redirect slug tiếng Việt cũ /vi-ca → /wallet.
                path: '/vi-ca',
                loader: () => redirect(routePaths.wallet),
              },
              {
                path: routePaths.inventory,
                element: <InventoryPage />,
              },
              {
                path: routePaths.clan,
                element: <ClanListPage />,
              },
              {
                path: routePaths.clanDetail,
                element: <ClanDetailPage />,
              },
              {
                path: routePaths.arena,
                element: <ArenaListPage />,
              },
              {
                path: routePaths.arenaDetail,
                element: <ArenaDetailPage />,
              },
              // Chuyển hướng URL tiếng Việt cũ → tiếng Anh mới (giữ link/bookmark cũ vẫn vào được)
              // Sàn hợp tác (14/10): thông báo đã gửi và backend vẫn dùng /hop-tac-quang-cao..., giữ nguyên query (?tab=...).
              {
                path: '/hop-tac-quang-cao',
                loader: ({ request }) => redirect(routePaths.brandDeals + new URL(request.url).search),
              },
              {
                path: '/hop-tac-quang-cao/viec/:dealId',
                loader: ({ params, request }) =>
                  redirect(`/collab/task/${params.dealId}${new URL(request.url).search}`),
              },
              {
                path: '/hop-tac-quang-cao/nguoi-dat/:adAccountId',
                loader: ({ params }) => redirect(`/collab/orderer/${params.adAccountId}`),
              },
              {
                path: '/thue-creator',
                loader: () => redirect(routePaths.brandOrderer),
              },
              {
                path: '/tim-kiem',
                loader: ({ request }) =>
                  redirect(routePaths.search + new URL(request.url).search),
              },
              {
                path: '/cua-hang',
                loader: () => redirect(routePaths.marketplace),
              },
              {
                path: '/kho-do',
                loader: () => redirect(routePaths.inventory),
              },
              {
                path: '/bang-hoi',
                loader: () => redirect(routePaths.clan),
              },
              {
                path: '/bang-hoi/:clanId',
                loader: ({ params }) => redirect(`/clan/${params.clanId}`),
              },
              {
                path: routePaths.profileUser,
                element: <ProfileUserPage />,
              },
              {
                path: routePaths.chat,
                element: <ChatPage />,
              },
              {
                path: routePaths.group,
                element: <GroupPage />,
              },
              {
                path: routePaths.groupDetail,
                element: <GroupDetail />,
              },
              {
                path: routePaths.category,
                element: <CategoryPage />,
              },
              {
                path: routePaths.hashtag,
                element: <HashtagPage />,
              },
              {
                path: '/post-uncheck',
                Component: PostUncheck,
              },
              {
                path: '/manage/histories',
                Component: TransactionHistory,
              },
              {
                path: routePaths.dating,
                Component: DatingPage,
              },
              {
                path: routePaths.studio,
                Component: StudioPage,
              },
              {
                path: routePaths.ads,
                Component: AdsPage,
              },
              {
                path: routePaths.shop,
                Component: ShopPage,
              },
              {
                path: routePaths.publisher,
                Component: PublisherPage,
              },
              {
                path: routePaths.partner,
                Component: PartnerPage,
              },
              {
                // Giữ link cũ /hop-tac (nếu đã share) → chuyển sang /partner (URL tiếng Anh).
                path: '/hop-tac',
                loader: () => redirect(routePaths.partner),
              },
              {
                // Giữ link cũ /shop hoạt động (đã share ra ngoài) → chuyển sang /affiliate.
                path: '/shop',
                loader: () => redirect(routePaths.shop),
              },
              {
                path: routePaths.daoCa,
                Component: DaoCaPage,
              },
            ],
          },
        ],
      },
      // {
      //   element: <BlankLayout />,
      //   children: [
      //     {
      //       element: <PrivateRoute />,
      //       children: [
      //         {
      //           path: routePaths.dating,
      //           Component: DatingPage,
      //         },
      //       ],
      //     },
      //   ],
      // },
      {
        element: <VideosLayout />,
        children: [
          {
            element: <PrivateRoute />,
            children: [
              {
                path: routePaths.videos,
                Component: VideosPage,
              },
              {
                path: routePaths.videoDetail,
                element: <VideosPage />,
              },
            ],
          },
        ],
      },
      {
        element: <BlankLayout />,
        children: [
          {
            element: <PrivateRoute />,
            children: [
              {
                path: routePaths.friend,
                element: <FriendPage />,
              },
              {
                path: `${routePaths.friend}/:userId`, // Matches "/share/..." with dynamic segments
                element: <FriendPage />, // Replace with your SharePage component
              },
              {
                path: `${routePaths.listFriend}/:userId`,
                element: <ListFriendPage />,
              },

              {
                path: routePaths.userSetting,
                Component: UserSetting,
              },
            ],
          },
        ],
      },
      {
        path: routePaths.notiDonate,
        element: <PageDonateLivestream />,
      },
      {
        // Overlay thanh tiến độ mục tiêu donate — chèn OBS, không cần đăng nhập.
        path: routePaths.donateGoalScreen,
        element: <PageDonateGoalLivestream />,
      },
      {
        // Overlay vòng quay — chèn OBS, không cần đăng nhập.
        path: routePaths.spinWheelScreen,
        element: <PageSpinWheelLivestream />,
      },
      {
        // Overlay bình chọn — chèn OBS, không cần đăng nhập.
        path: routePaths.donatePollScreen,
        element: <PageDonatePollLivestream />,
      },
      {
        // Overlay thử thách donate — chèn OBS, không cần đăng nhập.
        path: routePaths.donateChallengeScreen,
        element: <PageDonateChallengeLivestream />,
      },
      {
        // Overlay phát nhạc theo yêu cầu — chèn OBS, không cần đăng nhập (link có ?key=).
        path: routePaths.musicScreen,
        element: <PageMusicLivestream />,
      },
      {
        // Overlay hiệu ứng tương tác — chèn OBS, không cần đăng nhập (link có ?key=, mật khẩu OBS sau dấu #).
        path: routePaths.liveEffectScreen,
        element: <PageLiveEffectLivestream />,
      },
      {
        // Overlay hội viên kênh — chèn OBS, không cần đăng nhập (link có ?key=).
        path: routePaths.memberScreen,
        element: <PageMemberLivestream />,
      },
      {
        // Overlay quảng cáo livestream — chèn OBS, không cần đăng nhập (link có ?key=).
        path: routePaths.adScreen,
        element: <PageAdLivestream />,
      },
      {
        // Overlay đếm ngược subathon — chèn OBS, không cần đăng nhập.
        path: routePaths.subathonScreen,
        element: <PageSubathonLivestream />,
      },
      {
        // Overlay bảng xếp hạng donate — chèn OBS, không cần đăng nhập.
        path: routePaths.topDonateScreen,
        element: <PageTopDonateLivestream />,
      },
      {
        // Overlay hỏi đáp AI — chèn OBS, không cần đăng nhập (link có ?key=).
        path: routePaths.aiQuestionScreen,
        element: <PageAiQuestionLivestream />,
      },
      {
        // Link tiếp thị rút gọn — ai bấm cũng vào được, không cần đăng nhập.
        path: routePaths.affiliateGo,
        element: <AffiliateGoPage />,
      },
      {
        // Trang sản phẩm công khai — đích của link tiếp thị, xem không cần đăng nhập.
        path: routePaths.publicProduct,
        element: <PublicProductPage />,
      },
      {
        // Reels — player dọc toàn màn hình (không dùng layout để full-screen). Xem không cần đăng nhập.
        path: routePaths.reels,
        element: <ReelsPage />,
      },
    ],
  },

  {
    path: routePaths.register,
    Component: RegisterPage,
  },
  {
    path: routePaths.login,
    Component: LoginPage,
  },
  {
    path: routePaths.resetPassword,
    Component: ResetPasswordPage,
  },
  {
    path: '/reset-password',
    Component: ForgotPasswordPage,
  },
  {
    path: routePaths.verifyEmail,
    Component: VerifyAccountPage,
  },
  {
    path: routePaths.admin,
    element: <AdminLayout />,
    children: [
      {
        index: true,
        loader: async () => redirect('home'),
      },
      {
        path: 'home',
        Component: HomeAdmin,
      },
      {
        path: 'user/total',
        Component: ManagementUser,
      },
      {
        path: 'request-creator',
        Component: ManagementRequestCreator,
      },
      {
        path: 'ekyc-usage',
        Component: ManagementEkycUsage,
      },
      {
        path: 'donate/request',
        Component: ManagementRequestDonate,
      },
      {
        path: 'post/total',
        Component: ManagementPost,
      },
      {
        path: 'post/reported',
        Component: ManagementReportPost,
      },
      {
        path: 'post/hidden',
        Component: ManagementHiddenPost,
      },
      {
        path: 'comment/reported',
        Component: ManagementReportComment,
      },
      {
        path: 'profile-image/reported',
        Component: ManagementReportProfileImage,
      },
      {
        path: 'clan/reported',
        Component: ManagementReportClan,
      },
      {
        path: 'account/reported',
        Component: ManagementReportAccount,
      },
      {
        path: 'comment/hidden',
        Component: ManagementHiddenComment,
      },
      {
        path: 'donate/withdraw',
        Component: ManagementWithdrawRequest,
      },
      {
        path: 'donate/revenue',
        Component: ManagementRevenueReport,
      },
      {
        path: 'donate/topup',
        Component: ManagementTopUpReport,
      },
      {
        path: 'post/pending',
        Component: ManagementPendingPost,
      },
      {
        path: 'post/archive',
        Component: ManagementArchivePost,
      },
      {
        path: 'roles',
        Component: ManagementRoles,
      },
      {
        path: 'cosmetic',
        Component: ManagementCosmetic,
      },
      {
        path: 'su-kien-donate',
        Component: ManagementDonateEvent,
      },
      {
        path: 'ads',
        Component: ManagementAds,
      },
      {
        path: 'brand-deals',
        Component: ManagementBrandDeals,
      },
      {
        path: 'affiliate',
        Component: ManagementAffiliate,
      },
      {
        path: 'arena',
        Component: ManagementArena,
      },
      {
        path: 'publisher',
        Component: ManagementPublisher,
      },
      {
        path: 'consent',
        Component: ManagementConsent,
      },
      {
        path: 'gamification',
        Component: ManagementGamification,
      },
      {
        path: 'settings',
        Component: ManagementSettings,
      },
      {
        path: 'audit-log',
        Component: ManagementAuditLog,
      },
      {
        path: 'query-guard',
        Component: ManagementQueryGuard,
      },
      {
        path: 'security',
        Component: ManagementSecurity,
      },
    ],
  },
  {
    path: routePaths.admin,
    children: [
      {
        path: 'login',
        Component: AdminLoginPage,
      },
      {
        path: 'two-factor/:email',
        Component: LoginByCodePage,
      },
    ],
  },
  {
    path: '*',
    Component: NotFoundPage,
  },
  {
    path: '/payment',
    Component: VnPayResult,
  },
]);
